import * as Yup from 'yup';

const linkSubUnitsModalSchema = () => ({
  properties: Yup.array(Yup.object()).min(1).required(),
});

export default linkSubUnitsModalSchema;
